// extracted by mini-css-extract-plugin
export default {"iconDefault":"_3b3s6"};